import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLButtonElement> {
  static targets = ['segmented']

  declare readonly segmentedTargets: HTMLInputElement[]

  connect(): void {
    if (this.segmentedTargets.length === 0) return
    // make segmented input chosen with current value
    const indexMap = { dark: 0, light: 1, system: 2 }
    const theme = localStorage.theme as 'dark' | 'light' | 'system'
    const index = indexMap[theme] ?? 0
    this.segmentedTargets[index].setAttribute('checked', '')
  }

  modeClicked(e: Event): void {
    localStorage.theme = (e.currentTarget as HTMLInputElement).value
    document.location.reload()
  }
}
